export default "__VITE_ASSET__BilTKi5E__"